<script>
import {PeoAnalyse} from "@/api/personcenter";

export default {
	data() {
		return {
			myData: null,
			user: JSON.parse(this.$store.state.User.infos),
		}
	},
	watch: {
	},
	mounted() {
		PeoAnalyse({userId:this.user.id}).then(res => {
			console.log(res.result);
			let data = res.result;
			this.myData = data;
			this.init();
		})
	},
	methods: {
		init() {
			let canvas = document.getElementById('humanBody');
			const ctx = canvas.getContext('2d');

			function draw(e) {
				console.log(e.offsetX, e.offsetY);
			}
			canvas.addEventListener('mousedown', draw);

			function drawItem(x0, y0, x1, y1) {
				// 创建线性渐变
				let gradient = ctx.createLinearGradient(x0, y0, x1, y1);
				gradient.addColorStop(0, '#ff3600');      // 起点颜色
				gradient.addColorStop(0.3, '#b64c2f'); // 中间点颜色
				gradient.addColorStop(1, 'white');    // 终点颜色

				let cp1x = (x0+x1) / 2;
				let cp1y = (y0+y1) / 2 + 10;

				ctx.beginPath();
				ctx.moveTo(x0, y0); // 起点
				ctx.quadraticCurveTo(cp1x, cp1y, x1, y1); // 两个控制点和终点
				ctx.strokeStyle = gradient;
				ctx.lineWidth = 2;
				ctx.stroke();

				// 开始路径
				ctx.beginPath();
// 画一个半径为1的圆
				ctx.arc(x1, y1, 5, 0, Math.PI * 2);
// 填充颜色
				ctx.fillStyle = 'white';
				ctx.fill();
			}

			const img = new Image();
			img.onload = () => {
				// 首先绘制图片
				ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
				let arr = this.myData.list_fx;
				if (arr.indexOf('低血压风险') > -1) {
					drawItem(180, 22, 284, 56);
				}
				if (arr.indexOf('心血管风险') > -1 || arr.indexOf('高血压风险') > -1) {
					drawItem(190, 165, 55, 130)
				}
				if (arr.indexOf('糖尿病风险') > -1) {
					drawItem(179, 245, 340, 280)
				}
			};

			img.src = '/img/human-body2.jpeg'; // 替换为你的图片路径
		}
	}
}
</script>

<template>
	<div style="display: flex;justify-content: center;align-items: center;">
		<div style="position: relative;transform: scale(1.2)">
			<canvas id="humanBody" width="360" height="700"></canvas>
			<div v-if="myData">
				<div v-if="myData.list_fx.indexOf('低血压风险') > -1" class="ring-container"
				     style="position: absolute;left:42%;top: -10px;">
					<div class="center-dot"></div>
					<div class="ring"></div>
					<div class="ring"></div>
					<div class="ring"></div>
					<div class="ring"></div>
				</div>
				<div v-if="myData.list_fx.indexOf('心血管风险') > -1 || myData.list_fx.indexOf('高血压风险') > -1"
				     class="ring-container" style="position: absolute;left:160px;top: 135px;">
					<div class="center-dot"></div>
					<div class="ring"></div>
					<div class="ring"></div>
					<div class="ring"></div>
					<div class="ring"></div>
				</div>
				<div v-if="myData.list_fx.indexOf('糖尿病风险') > -1" class="ring-container"
				     style="position: absolute;left:149px;top: 215px;">
					<div class="center-dot"></div>
					<div class="ring"></div>
					<div class="ring"></div>
					<div class="ring"></div>
					<div class="ring"></div>
				</div>
				<div v-if="myData.list_fx.indexOf('低血压风险') > -1" class="name-container" style="position: absolute;right: -50px;top: 40px">
					<div class="left"></div>
					<div class="right">低血压风险</div>
				</div>
				<div v-if="myData.list_fx.indexOf('糖尿病风险') > -1"
				     class="name-container" style="position: absolute;right: -110px;top: 265px">
					<div class="left"></div>
					<div class="right">糖尿病风险</div>
				</div>
				<div style="position: absolute;left: -70px;top: 111px">
					<div  v-if="myData.list_fx.indexOf('心血管风险') > -1" class="name-container">
						<div class="left"></div>
						<div class="right">心血管风险</div>
					</div>
					<div v-if="myData.list_fx.indexOf('高血压风险') > -1" class="name-container" style="margin-top: 5px;">
						<div class="left"></div>
						<div class="right">高血压风险</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped lang="scss">
.name-container {
	border: 1px solid gray;
	color: white;
	display: flex;
	align-items: center;
	padding: 5px;

	.left {
		width: 15px;
		height: 15px;
		background-color: #DE4F27;
		margin-right: 10px;
		border: 1px solid gray;
	}
	.right {
		line-height: 1em;
	}
}
.ring-container {
	position: relative;
	width: 60px;
	height: 60px;
	border-radius: 50%;
}

.ring {
	position: absolute;
	border: 2px solid #DE4F27;
	box-sizing: content-box;
	border-radius: 50%;
	opacity: 0;

	animation: ripple 2s linear infinite;
}

.ring:nth-child(1) {
	animation-delay: 0s;
}

.ring:nth-child(2) {
	animation-delay: 0.5s;
}

.ring:nth-child(3) {
	animation-delay: 1s;
}

.ring:nth-child(4) {
	animation-delay: 1.5s;
}
@keyframes ripple {
	0% {
		width: 12px;
		height: 12px;
		opacity: 1;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	100% {
		width: 60px;
		height: 60px;
		opacity: 0;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
}

/* 中心点 */
.center-dot {
	position: absolute;
	width: 12px;
	height: 12px;
	background-color: #D74D22;
	border-radius: 50%;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
</style>